import React from 'react';
import CashierActionButton from '../../components/CashierActionButton';
import ModalWeight, { useModalWeightRef } from './ModalWeight';
import { IUISelectItem } from '../../cashier.interface';
type Props = {
  add: (item: IUISelectItem) => void;
};
const CashierWeight = ({ add }: Props) => {
  const modalRef = useModalWeightRef();
  const onClick = () => modalRef.current?.open();
  return (
    <>
      <CashierActionButton
        type='WEIGHT'
        onClick={onClick}
      />
      <ModalWeight add={add} ref={modalRef} />
    </>
  );
};

export default CashierWeight;
